import { Component, Input } from '@angular/core';
import { ContextSwitchTypeaheadEntry } from '@app/menu/components/context-switcher/context-switch-typeahead-entry';
import { MenuService } from '@app/menu/services/menu.service';
import { TypeaheadEntry } from '@app/shared/services/typeahead-basket.service';
import { TrunkViewModel } from '@business/trunk/models/trunk-view-model';

@Component({
  selector: 'portal-trunk-switcher',
  templateUrl: './trunk-switcher.component.html',
  styles: [],
  standalone: false,
})
export class TrunkSwitcherComponent {
  @Input()
  public trunk: TrunkViewModel;

  @Input()
  public trunks: TypeaheadEntry<string>[];

  constructor(private menuService: MenuService) {}

  public switchRoute(typeaheadEntry: ContextSwitchTypeaheadEntry) {
    if (typeaheadEntry.value !== this.trunk._original.db.number) {
      this.menuService.switch('trunkId', {
        trunkId: typeaheadEntry.value,
      });
    }
  }
}
